module.exports = __webpack_public_path__ + "static/media/my-icon.cb675d96.png";